import React, { useState } from "react";
import { Card, Form, Input, Button, Upload, message } from "antd";
import { UploadOutlined, FilePdfOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom"; 
import { createCandidateApi } from "../../../apiservice/ats";

const CreateCandidate = () => {
  const [form] = Form.useForm();
  const [photoList, setPhotoList] = useState([]);
  const [resumeList, setResumeList] = useState([]);
  const navigate = useNavigate();

  const handlePhotoChange = ({ fileList }) => setPhotoList(fileList);
  const handleResumeChange = ({ fileList }) => setResumeList(fileList);

  const onFinish = async (values) => {
    try {
      const formData = new FormData();

      // Append all form fields
      Object.entries(values).forEach(([key, value]) => {
        formData.append(key, value);
      });

      // Append photo if exists
      if (photoList.length > 0) {
        formData.append("photo", photoList[0].originFileObj);
      }

      // Append resume if exists
      if (resumeList.length > 0) {
        formData.append("resume", resumeList[0].originFileObj);
      }

      await createCandidateApi(formData); // backend should handle FormData
      message.success("Candidate created successfully");
      navigate("/ats/candidates");
    } catch (err) {
      console.error(err);
      message.error("Failed to create candidate");
    }
  };

  return (
    <Card title="Add Candidate">
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item label="Name" name="name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item label="Email" name="email" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item label="Job Title" name="job_title">
          <Input />
        </Form.Item>

        <Form.Item label="Status" name="status">
          <Input />
        </Form.Item>

        {/* Photo Upload */}
        <Form.Item label="Photo">
          <Upload
            beforeUpload={() => false} // prevent auto upload
            fileList={photoList}
            onChange={handlePhotoChange}
            accept="image/*"
            maxCount={1}
          >
            <Button icon={<UploadOutlined />}>Select Photo</Button>
          </Upload>
        </Form.Item>

        {/* Resume Upload */}
        <Form.Item label="Resume">
          <Upload
            beforeUpload={() => false} // prevent auto upload
            fileList={resumeList}
            onChange={handleResumeChange}
            accept=".pdf,.doc,.docx"
            maxCount={1}
          >
            <Button icon={<FilePdfOutlined />}>Select Resume</Button>
          </Upload>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save Candidate
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default CreateCandidate;
